import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ReactSVG } from 'react-svg';
import * as Icons from './RFSvg.Icons';
import s from './RFSvg.module.css';
const RFSvgFC = ({ name, size = 's16', width, height }) => {
    const style = width && height ? { width: `${width}px`, height: `${height}px` } : {};
    if (!name) {
        return _jsx(_Fragment, {});
    }
    return _jsx(ReactSVG, { title: "", src: Icons[name], style: style, className: s[size] });
};
export const RFSvg = RFSvgFC;
//# sourceMappingURL=RFSvg.js.map